// extracted by mini-css-extract-plugin
export default {"editPoll":"EditPollModal_editPoll__pxwX9"};